module.exports = __webpack_public_path__ + "assets/snowgem.2f047ec2.png";